import type { EntityMenuToken, Theme } from 'hephaestus/core';
import { merge } from 'lodash-es';

export const useEntityMenuTokens = (theme: Theme): EntityMenuToken => {
  const { palette, borderRadius, component } = theme;
  const base = {
    avatar: {
      backgroundColor: palette.supportOne10,
      foregroundColor: palette.supportOne60,
    },
    borderRadius: borderRadius.lg,
  };

  return merge({}, base, component?.entityMenu) as EntityMenuToken;
};
